export default __webpack_public_path__ + "static/mobile_bg-288bf0eea318ad8aae8d4d074a3d3cad.png";